import { motion } from "framer-motion";

export const Preloader = () => {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-white"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
    >
      <div className="pointer-events-none absolute w-[420px] h-[420px] bg-blue-500/10 rounded-full blur-[120px]" />

      <div className="relative flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.85, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col items-center"
        >
          <motion.span
            className="font-heading font-extrabold text-5xl sm:text-6xl text-slate-900 tracking-tight"
            initial={{ letterSpacing: "0.4em", opacity: 0 }}
            animate={{ letterSpacing: "-0.02em", opacity: 1 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          >
            BERISHA
          </motion.span>
          <motion.span
            className="text-blue-600 text-xs sm:text-sm tracking-[0.35em] uppercase mt-1"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.6 }}
          >
            Autoaufbereitung
          </motion.span>
        </motion.div>

        <motion.div
          className="h-0.5 bg-blue-600 mt-6 rounded-full"
          initial={{ width: 0 }}
          animate={{ width: 180 }}
          transition={{ delay: 0.4, duration: 1, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
    </motion.div>
  );
};
